import React from 'react';
import { useEmployee } from '../contexts/EmployeeContext';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export const InactivityWarning: React.FC = () => {
  const { showInactivityWarning, secondsUntilLock, dismissWarning, employee } = useEmployee();

  if (!showInactivityWarning) return null;

  // Format seconds as MM:SS for longer countdowns
  const formatCountdown = (secs: number) => {
    if (secs >= 60) {
      const mins = Math.floor(secs / 60);
      const remainingSecs = secs % 60;
      return `${mins}:${remainingSecs.toString().padStart(2, '0')}`;
    }
    return secs.toString();
  };

  return (
    <div className="fixed bottom-4 right-4 z-[60]">
      <div className="bg-amber-50 border-2 border-amber-400 rounded-xl shadow-2xl p-4 max-w-sm">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon className="w-8 h-8 text-amber-600 animate-pulse" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-amber-800">
              Session Timeout Warning
            </h3>
            <p className="text-sm text-amber-700 mt-1">
              {employee?.first_name}, you've been inactive.
            </p>
            <div className="mt-2 flex items-center gap-2">
              <div className="text-3xl font-bold text-amber-900 animate-pulse">
                {formatCountdown(secondsUntilLock)}
              </div>
              <div className="text-sm text-amber-700">
                {secondsUntilLock >= 60 ? 'until' : 'seconds until'}<br />auto-lock
              </div>
            </div>
            <button
              onClick={dismissWarning}
              className="mt-3 w-full px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-medium rounded-lg transition-colors"
            >
              I'm Still Here
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
